import { ComponentPropsWithRef, forwardRef, memo } from 'react';
import { Span, SpanProps } from '@chakra-ui/react';

const LightModeComponent = (
  props: SpanProps,
  ref: ComponentPropsWithRef<'span'>['ref'],
) => (
  <Span
    ref={ref}
    className="chakra-theme light"
    color="fg"
    colorPalette="gray"
    colorScheme="light"
    display="contents"
    {...props}
  />
);

export const LightMode = memo(
  forwardRef<HTMLSpanElement, SpanProps>(LightModeComponent),
);
